import type { FaireProductEntity } from "../../entity_types/product";

export const p_fkz98dcqqg: FaireProductEntity = {
  token: "p_fkz98dcqqg",
  type: "product",
  name: "Strawberry Farm Tea Towel",
  brandToken: "b_9n6zhnblbf",
  brandName: "Geometry",
  imageUrl: "https://cdn.faire.com/fastly/a2695f5bdb9250845b4a9a54f13cc1e23bf80c2ac7dc756be91d4f1829435c57.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/daee904ae258b14eea4a2da1bff8a1d3cd634b93f680ef201825d5b328daaf1c.jpeg",
    "https://cdn.faire.com/fastly/449559311b05e568e4b20b8781ee5f29f6aaa58dbb041162a50952a8442bfc1d.jpeg",
    "https://cdn.faire.com/fastly/bb3f9b46d08eca5e6ee1d7dfe7c904d20fb5f02a885398145533433131ea0d79.jpeg"
  ],
  priceDollars: 9,
  description: "Kitchen Tea Towel\n\nThrow in the (ordinary) towel. \n\nMeet the product that started it all. The Geometry House Tea Towel is a cult favorite for a reason. Created from a tightly-woven Geoweave™ fabric that is ultra-absorbent, quick-drying and never wrinkles, this towel is built to work – while looking like a dream.\n\n\n...\n\n * ♺ Made from post-consumer recycled materials \n * 18\" x 30\" \n * Single-sided print \n * 100% Satisfaction Guarantee \n * No questions asked, hassle-free returns \n...\n\n\nChore responsibly. \n\nFrom drying dishes to wiping up spills to accenting your kitchen with the season’s most enchanting prints, this Tea Towel does it all – without a negative impact on the environment. Our towels are created from post-consumer recycled products using less water than traditional methods and minimizing our carbon footprint. And due to its patented weave, high absorbency and quick dry time, you can clean with fewer harsh chemicals and wash it less often, reducing yours. \n\nImpact your home, not the environment. Discover the Geometry Tea Towel.\n",
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T20:59:43.245Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
